import { SuspectedActorsCardWebComponent } from './component/SuspectedActorsCardWebComponent';

export { SuspectedActorsCardWebComponent };
